import {
  Box,
  ButtonNew,
  ColorOptions,
  convertHexToRGBA,
  Icon,
  Image,
  ModBox,
  Text,
  useWindowDimensions,
} from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useState } from 'react'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'
import { SideMenu } from './SideMenu'

export const Header = () => {
  const resPadding = usePadding()
  const { navigate } = useNavigation()
  const viewportWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewportWidth)

  const [navVisible, setNavVisible] = useState(false)
  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }

  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }

  const nav = (
    <Box>
      <SideMenu onPress={setVisiblity} />
    </Box>
  )

  return (
    <Box justify={'space-between'} pv={isMobile ? 24 : 40} ph={resPadding} flexDirection={'row'} align={'center'}>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Box onPress={() => navigate('jiopay')} underlayColor={'TRANSPARENT'}>
        <Image
          source={require('../../assets/images/jio-pay-logo.png')}
          width={isMobile ? 64 : 81}
          height={isMobile ? 32 : 40}
        />
      </Box>
      {!isMobile && (
        <Box gap={48} flexDirection={'row'} align={'center'}>
          <Text
            title={'About Us'}
            color={'#F7F7F7' as ColorOptions}
            fontFamily={'jiotype-medium'}
            fontSize={16}
            onPress={() => navigate('about-us')}
          />
          <Text
            title={'Contact Us'}
            color={'#F7F7F7' as ColorOptions}
            fontFamily={'jiotype-medium'}
            fontSize={16}
            onPress={() => navigate('contact')}
          />
          <ButtonNew
            title={'For Business'}
            onPress={() => navigate('jiopay')}
            color={'WHITE'}
            titleColor={'#000092' as ColorOptions}
            height={42}
            borderRadius={24}
            paddingHorizontal={32}
          />
        </Box>
      )}
      <ModBox
        show={isMobile}
        underlayColor="TRANSPARENT"
        backgroundColor={'#FFFFFF29' as ColorOptions}
        w={32}
        h={32}
        borderRadius={16}
        align={'center'}
        justify={'center'}
        onPress={handleNav}>
        <Icon id={'HAMBURGER_MENU'} color={convertHexToRGBA('#ffffff', 76) as ColorOptions} size={16} />
      </ModBox>
    </Box>
  )
}
